/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Mild_Stork_BiteInputs */

const en_flat_mild_stork_bite = /** @type {(inputs: Flat_Mild_Stork_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show details`)
};

const de_flat_mild_stork_bite = /** @type {(inputs: Flat_Mild_Stork_BiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details anzeigen`)
};

/**
* | output |
* | --- |
* | "Show details" |
*
* @param {Flat_Mild_Stork_BiteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flat_mild_stork_bite = /** @type {((inputs?: Flat_Mild_Stork_BiteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Mild_Stork_BiteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flat_mild_stork_bite(inputs)
	return de_flat_mild_stork_bite(inputs)
});